module.exports = __webpack_public_path__ + "static/media/preloader.03671802.gif";